import { useThemeConfig } from '../model/store/theme-config'
import { useTheme } from 'next-themes'
import { selectThemeConfig } from '../model/selectors/theme'
import { DefaultThemes } from '@/shared/config/theme/lib/theme'

export function useToggleTheme() {
  const { setTheme, theme } = useTheme()
  const mode = useThemeConfig(selectThemeConfig)
  const dark = mode.dark || DefaultThemes['dark']
  const light = mode.light || DefaultThemes['light']

  const toggleTheme = () => setTheme(theme === light ? dark : light)

  return { toggleTheme, theme }
}
